import { RequestStatus } from 'shared/types';

export const checkRequestStatusEquality = (actionTypes: string, requestStatus = RequestStatus.REQUEST) => {
  return requestStatus === actionTypes;
};
